/**
 * C2BInstructionsDialog Component
 * Shows M-Pesa payment instructions for customer
 */

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Phone, CheckCircle, Loader2 } from "lucide-react";

export function C2BInstructionsDialog({
  open,
  onOpenChange,
  mpesaSettings,
  invoice,
  formatCurrency,
  processing,
  onConfirm
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="c2b-instructions-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Phone className="h-5 w-5 text-green-600" />
            M-Pesa Payment Instructions
          </DialogTitle>
          <DialogDescription>
            Ask customer to pay using the details below
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border-2 border-green-500 space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-sm text-muted-foreground">
                {mpesaSettings?.c2b_shortcode_type === "till" ? "Till Number" : "Paybill Number"}
              </span>
              <span className="font-mono text-xl font-bold text-green-700 dark:text-green-400">
                {mpesaSettings?.business_short_code}
              </span>
            </div>
            
            {mpesaSettings?.c2b_shortcode_type !== "till" && (
              <div className="flex justify-between items-center border-t border-green-200 dark:border-green-700 pt-3">
                <span className="text-sm text-muted-foreground">Account Number</span>
                <span className="font-mono text-lg font-bold text-green-700 dark:text-green-400">
                  {invoice?.invoice_number?.slice(-4) || "----"}
                </span>
              </div>
            )}
            
            <div className="flex justify-between items-center border-t border-green-200 dark:border-green-700 pt-3">
              <span className="text-sm text-muted-foreground">Amount</span>
              <span className="font-mono text-xl font-bold text-green-700 dark:text-green-400">
                {formatCurrency(invoice?.total || 0)}
              </span>
            </div>
          </div>
          
          <div className="text-sm text-muted-foreground space-y-1">
            <p>• Customer enters <strong>last 4 digits</strong> of invoice as account number</p>
            <p>• Full invoice number also works: <span className="font-mono">{invoice?.invoice_number}</span></p>
            <p>• Payment will be automatically matched to this invoice</p>
          </div>
        </div>
        
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="w-full sm:w-auto" data-testid="c2b-cancel-btn">
            Cancel
          </Button>
          <Button 
            onClick={onConfirm} 
            disabled={processing} 
            className="w-full sm:w-auto bg-green-600 hover:bg-green-700"
            data-testid="c2b-confirm-btn"
          >
            {processing ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <CheckCircle className="mr-2 h-4 w-4" />}
            {processing ? "Processing..." : "Mark as Awaiting Payment"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
